// extracted by mini-css-extract-plugin
export default {"container":"container-RWXaE","headingWrapper":"headingWrapper-cB5N9","heading":"heading-hXtR3","icon":"icon-rnbC1"};